import _ from 'lodash';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiHomeAlt } from "react-icons/bi";
import { MdOutlineAccountBalanceWallet, MdOutlineAccountTree, MdOutlineSettings } from "react-icons/md";
import { useSelector } from 'react-redux';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { storePaths } from '@utils/Tools';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';

const MAIN_NAVIGATE = ['home', 'wallets', 'community', 'setting', 'packages'];
const HIDE_BAR = ['/landing', '/login', '/register', '/reset-password', '/contact-us', '/recruit', '/setting/profile', '/setting/crypto-address', '/setting/password', '/setting/security-password', '/maintenance', '/forgot-password', '/email-verification', '/wallet-listing', '/packages/histories', '/notices', '/packages/purchase', '/commission-listing', '/wallet/transactionHistory', 'commission/transactionHistory'];

const BottomNavigationBar = memo(() => {
    const styles = useStyles();
    let location = useLocation();
    let navigate = useNavigate();
    const theme = useTheme();
    const { t } = useTranslation();

    const [value, setValue] = useState('home');
    const [hideBar, setHideBar] = useState(false);

    const { accessToken } = useSelector(state => state.general);
    let path = location.pathname.split('/');

    useEffect(() => {
        setHideBar(false);
        let temp_value = _.intersection(MAIN_NAVIGATE, path);
        if (_.size(temp_value) > 0) {
            setValue(temp_value[0]);
        } else {
            if (path[1] === 'wallet') {
                setValue('wallets');
                if (path[2] === 'transactionHistory') {
                    setHideBar(true);
                }
            } else if (path[1].includes('tutorial')) {
                setHideBar(true);
            }
            else {
                setValue('home');
            }
        }
    }, [path]);

    if (_.includes(HIDE_BAR, location.pathname) || hideBar || _.includes(HIDE_BAR, path.slice(1, 3).join('/'))) {
        return null;
    }
    else {
        return (
            <div className='pos-fixed w-full' style={{ maxWidth: '100%', top: 'auto', bottom: 0, zIndex: 1, width: 444 }}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    style={{ width: '100%', maxWidth: 'inherit', boxShadow: 'inset #d7c9ac2e 0px 2px 6px 0px', height: 61, justifyContent: 'space-around' }}
                    sx={{
                        "& .css-72wtuy-MuiButtonBase-root-MuiBottomNavigationAction-root": {
                            minWidth: 0
                        },
                        '& .Mui-selected': {
                            '& .MuiBottomNavigationAction-label': {
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                [theme.breakpoints.down('sm')]: {
                                    width: '55px',
                                },
                            },
                        },
                    }}
                >
                    <BottomNavigationAction
                        to={accessToken ? "/" : "/login"}
                        state={{ from: storePaths(location) }}
                        component={RouterLink}
                        label={t('title.home')}
                        icon={<BiHomeAlt className="img-style" />}
                        value="home"
                        className='txt-truncate'
                        style={{ textAlign: 'center', minWidth: 'unset', width: '15%' }}
                    />
                    <BottomNavigationAction
                        to={accessToken ? "/wallets/wallet" : "/login"}
                        state={{ from: storePaths(location) }}
                        label={t('title.wallet')}
                        component={RouterLink}
                        icon={<MdOutlineAccountBalanceWallet className="img-style" />}
                        value="wallets"
                        className='txt-truncate'
                        style={{ textAlign: 'center', minWidth: 'unset', width: '15%' }}
                    />
                    <BottomNavigationAction
                        to={accessToken ? "/packages/histories" : "/login"}
                        // state={{ from: location }}
                        state={{ from: storePaths(location) }}
                        label={t('title.package')}
                        component={RouterLink}
                        icon={
                            <div style={{ width: 92, display: 'flex', justifyContent: 'center'  }}>
                                <div className='flex-c-m flex-col w-full pointer' onClick={accessToken ? () => navigate('/packages/purchase') : () => navigate('/login')} >
                                    <div style={{ width: 24, height: 24 }} />
                                    <img src={`/images/wallet/coin.png`} alt="icon" className={`${styles.iconStyle} ${_.isEqual(location.pathname, '/packages/purchase') ? '' : 'coin-animate'}`} style={{ marginTop: -47, position: 'fixed' }} />
                                </div>
                            </div>
                        }
                        value="packages"
                        className='txt-truncate'
                        style={{ textAlign: 'center', minWidth: 'unset', width: '15%' }}
                        // disabled
                    // sx={{
                    //     '.MuiBottomNavigationAction-label': {
                    //         fontSize: 14,
                    //         fontWeight: 600,
                    //         fontFamily: 'system-ui',
                    //         textTransform: "uppercase"
                    //     }
                    // }}
                    />
                    <BottomNavigationAction
                        to={accessToken ? "/community/sponsor" : "/login"}
                        state={{ from: storePaths(location) }}
                        component={RouterLink}
                        label={t('title.genealogy')}
                        // target='_top'
                        icon={<MdOutlineAccountTree className="img-style" />}
                        value="community"
                        className='txt-truncate'
                        style={{ textAlign: 'center', minWidth: 'unset', width: '15%' }}
                    />
                    <BottomNavigationAction
                        to={accessToken ? "/setting" : "/login"}
                        state={{ from: storePaths(location) }}
                        component={RouterLink}
                        label={t('title.setting')}
                        icon={<MdOutlineSettings className="img-style" />}
                        value="setting"
                        className='txt-truncate'
                        style={{ textAlign: 'center', minWidth: 'unset', width: '15%' }}
                    />
                </BottomNavigation>
            </div>
        )
    }
});

const useStyles = makeStyles((theme) => ({
    iconStyle: {
        width: 67,
        flexShrink: 0,
        mixBlendMode: 'lighten',
    },
}));

export default BottomNavigationBar;